import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TAiReviewPageMessageChatDto, useAvApi } from '@app-velocity/av-api-v2';

export const useAiPageDiscussionMutation = (
  shareToken?: string,
  reviewId?: string,
  parentId?: string
) => {
  const { prototypesShare } = useAvApi();

  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['ai-page-discussion', 'figma', shareToken, parentId],
    mutationFn: async ({
      body,
      pageId,
    }: {
      body: TAiReviewPageMessageChatDto;
      pageId: string;
    }) => {
      if (!shareToken || !pageId || !reviewId || !parentId) return;

      const res =
        await prototypesShare.postV2PrototypesShareAiReviewPagesChatByShareTokenAndReviewIdAndPageIdAndParentId(
          body,
          {
            shareToken,
            pageId,
            reviewId,
            parentId,
          }
        );

      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['chat-conversation', 'figma', shareToken, parentId],
      });
    },
  });
};
